// gap between cards in row
export const ROW_GAP = {
  SIZE_10: '--row-gap-size-10',
  SIZE_20: '--row-gap-size-20',
  SIZE_30: '--row-gap-size-30',
} as const
export type ROW_GAP = (typeof ROW_GAP)[keyof typeof ROW_GAP]

//gap between row header and row itself
export const ROW_CONTAINER_VERTICAL_GAPS = {
  SpecialRowWithHeaderDefault: '--row-container-gap-special-header',
  RowDefault: '--row-container-gap-default',
  RowWithoutHeader: '--row-container-gap-without-header',
} as const
export type ROW_CONTAINER_VERTICAL_GAPS =
  (typeof ROW_CONTAINER_VERTICAL_GAPS)[keyof typeof ROW_CONTAINER_VERTICAL_GAPS]
